import { MetalsHardwareItemType } from "../enums/metals-hardware-item-type.enum";

export const metalsHardwareItemTypePrefixDict: Record<MetalsHardwareItemType, string> = {
        [MetalsHardwareItemType.SheetMetal]: 'SM',
        [MetalsHardwareItemType.PaintPowder]: 'PC',
        [MetalsHardwareItemType.Hardware]: 'HW',
        [MetalsHardwareItemType.Coil]: 'C',
        [MetalsHardwareItemType.Pem]: 'PEM',
        [MetalsHardwareItemType.Misc]: 'MI'
}


